import React, { useState } from "react";
import { useSeo } from "@/hooks/useSeo";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function LoginPage() {
  useSeo({ title: "Sign in", description: undefined, path: "/login", noindex: true });
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      // Route admins straight to the control room
      const next = new URLSearchParams(window.location.search).get("next"); const safeNext = next && next.startsWith("/") && !next.startsWith("//") ? next : null;
      nav(safeNext || (u && u.role === "admin" ? "/admin" : "/dashboard"));
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally { setLoading(false); }
  };

  const quick = (em, pw) => { setEmail(em); setPassword(pw); };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <form onSubmit={submit} className="card-warm p-8 w-full max-w-md">
        <div className="eyebrow mb-2">Welcome back</div>
        <h1 className="font-display text-3xl mb-6">Log in to CSI</h1>
        <label className="block text-sm font-semibold mb-1">Email</label>
        <input type="email" className="field mb-4" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"/>
        <div className="flex items-center justify-between mb-1">
          <label className="block text-sm font-semibold">Password</label>
          <Link to="/forgot-password" className="text-xs font-semibold text-[var(--terracotta)] hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
        </div>
        <input type="password" className="field mb-4" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"/>
        {err && <div className="text-sm text-red-600 mb-3" data-testid="login-error">{err}</div>}
        <button disabled={loading} className="btn-terracotta w-full py-3 rounded-full text-sm font-semibold disabled:opacity-70" data-testid="login-submit-btn">
          {loading ? "Logging in…" : "Log in"}
        </button>
        <div className="text-sm text-zinc-600 mt-4 text-center">
          New to CSI? <Link to="/register" className="font-semibold text-[var(--terracotta)]">Create account</Link>
        </div>
        {window.location.hostname.includes("preview.emergentagent.com") && <div className="mt-6 pt-6 border-t border-[var(--border-warm)]">
          <div className="eyebrow mb-2">Try a demo account</div>
          <div className="flex gap-2 flex-wrap">
            <button type="button" className="chip" onClick={() => quick("lee@kiteacademy.com", "student123")} data-testid="demo-student-btn">Student</button>
          </div>
        </div>}
        <style>{`
          .field { width: 100%; background: #fff; border: 1px solid var(--border-warm); border-radius: 12px; padding: 10px 14px; font-size: 14px; outline: none; }
          .field:focus { border-color: var(--ink); }
        `}</style>
      </form>
    </div>
  );
}
